<template>
  <div class="common-layout">
    <el-container>
      <el-main>
        <div style="margin: 50px 100px">
          <h2 style="font-size: 30px; color: #617173;">
            宗旨
          </h2>
          <h2 style="font-size: 20px; color: #617173;">
            「深耕青年成長，共築中醫未來」
          </h2>
          <p style="font-size: 20px; color: #617173; margin-top: 10px">
            專注於青年中醫師及中醫學生的專業發展需求，提供系統化學習資源、實務經驗與職業支持，
          </p>
          <p style="font-size: 20px; color: #617173;">
            強化青年群體在中醫領域的核心競爭力，推動中醫藥現代化與國際化。
          </p>
        </div>
        <el-divider style="width: 1200px;margin-left: 100px" />
        <div style="margin: 50px 100px">
          <h2 style="font-size: 30px; color: #617173;">
            願景
          </h2>
          <p style="font-size: 20px; color: #617173; margin-top: 10px">
            成為大中華區青年中醫師及學生的首選支持平臺，打造「以青年為本」的中醫人才生態圈，
          </p>
          <p style="font-size: 20px; color: #617173;">
            促進粵港澳大灣區中醫藥產業創新，並培育兼具傳統底蘊與現代視野的新世代中醫領袖。
          </p>
        </div>
      </el-main>
      <el-divider style="width: 1350px;margin-left: 30px" />
      <el-footer>
        <div>
          <div style="color: #617173; text-align:center; font-size: 10px;margin-bottom: 10px">
            華夏青年中醫協會
          </div>
          <div style="margin-left: 610px; margin-bottom: 20px">
            <img src="../assets/logo1.png" alt="Logo" style="width: 170px; height: auto">
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "AboutUs"
}
</script>

<style scoped>

</style>
